// Cart Preorder Extension - Extends Dawn's existing cart functionality
// Add this as assets/cart-preorder-extension.js

// Define functions first
function updateQuantityButtons() {
  const quantityInputs = document.querySelectorAll('.quantity__input[type="number"]');
  
  quantityInputs.forEach(input => {
    const currentValue = parseInt(input.value) || 0;
    const preorderLimit = parseInt(input.dataset.preorderLimit) || 0;
    const maxQuantity = parseInt(input.getAttribute('max')) || 0;
    
    // Find the + and - buttons for this input
    const quantityWrapper = input.closest('.quantity') || input.closest('.cart-item__quantity');
    if (!quantityWrapper) return;
    
    const plusButton = quantityWrapper.querySelector('.quantity__button[name="plus"]');
    const minusButton = quantityWrapper.querySelector('.quantity__button[name="minus"]');
    
    if (plusButton) {
      // Determine the effective maximum (preorder limit or regular max)
      let effectiveMax = 0;
      
      if (preorderLimit > 0) {
        effectiveMax = preorderLimit;
      } else if (maxQuantity > 0) {
        effectiveMax = maxQuantity;
      }
      
      // Disable plus button if at or above limit
      if (effectiveMax > 0 && currentValue >= effectiveMax) {
        plusButton.disabled = true;
        plusButton.setAttribute('aria-disabled', 'true');
        plusButton.style.opacity = '0.5';
        plusButton.style.cursor = 'not-allowed';
        
        // Add title/tooltip to explain why it's disabled
        if (preorderLimit > 0) {
          plusButton.title = `Preorder limit of ${preorderLimit} reached`;
        } else {
          plusButton.title = `Maximum quantity of ${maxQuantity} reached`;
        }
      } else {
        // Re-enable plus button if below limit
        plusButton.disabled = false;
        plusButton.removeAttribute('aria-disabled');
        plusButton.style.opacity = '';
        plusButton.style.cursor = '';
        plusButton.removeAttribute('title');
      }
    }
    
    if (minusButton) {
      const minQuantity = parseInt(input.getAttribute('min')) || 0;
      
      // Disable minus button if at minimum
      if (currentValue <= minQuantity) {
        minusButton.disabled = true;
        minusButton.setAttribute('aria-disabled', 'true');
        minusButton.style.opacity = '0.5';
        minusButton.style.cursor = 'not-allowed';
      } else {
        minusButton.disabled = false;
        minusButton.removeAttribute('aria-disabled');
        minusButton.style.opacity = '';
        minusButton.style.cursor = '';
      }
    }
  });
}

function extendCartItems() {
  // Get the existing CartItems class
  const CartItemsClass = customElements.get('cart-items');
  if (!CartItemsClass) {
    console.log('CartItems not found, retrying...');
    setTimeout(extendCartItems, 100);
    return;
  }

  // Store the original validateQuantity method
  const originalValidateQuantity = CartItemsClass.prototype.validateQuantity;

  // Override the validateQuantity method
  CartItemsClass.prototype.validateQuantity = function(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    
    // Check preorder limit first
    const preorderLimit = parseInt(event.target.dataset.preorderLimit) || 0;
    if (preorderLimit > 0 && inputValue > preorderLimit) {
      const message = `Maximum ${preorderLimit} item${preorderLimit > 1 ? 's' : ''} allowed for preorder`;
      
      // Set the input value to the preorder limit
      event.target.value = preorderLimit;
      
      // Use Dawn's existing setValidity method to show the error
      this.setValidity(event, index, message);
      
      // Update button states after validation
      setTimeout(() => updateQuantityButtons(), 50);
      return;
    }

    // Call the original validateQuantity method for all other validations
    originalValidateQuantity.call(this, event);
    
    // Update button states after any validation
    setTimeout(() => updateQuantityButtons(), 50);
  };

  console.log('Cart preorder extension loaded successfully');
}

// Event listeners and initialization
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Dawn's CartItems to be defined
  setTimeout(() => {
    extendCartItems();
  }, 100);
  
  // Also extend CartDrawerItems if it exists (it extends CartItems)
  setTimeout(() => {
    const CartDrawerItemsClass = customElements.get('cart-drawer-items');
    if (CartDrawerItemsClass) {
      // CartDrawerItems inherits from CartItems, so it will automatically get our extension
      console.log('Cart drawer preorder extension ready');
    }
  }, 200);
  
  // Add indicators and update buttons when page loads
  setTimeout(() => {
    updateQuantityButtons();
  }, 300);
});

// Listen for cart updates to re-add indicators and update buttons
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setTimeout(() => {
      updateQuantityButtons();
    }, 100);
  });
}

// Also listen for input changes to update button states in real-time
document.addEventListener('change', function(event) {
  if (event.target.matches('.quantity__input[type="number"]')) {
    setTimeout(updateQuantityButtons, 10);
  }
});

// Listen for button clicks to update states immediately after
document.addEventListener('click', function(event) {
  if (event.target.matches('.quantity__button')) {
    setTimeout(updateQuantityButtons, 50);
  }
});